/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'reload': {
    width: 17,
    height: 21,
    viewBox: '0 0 17 21',
    data: '<path pid="0" _fill="#008cff" d="M16.942 13.627c-.447 3.83-3.588 6.891-7.508 7.32-4.682.51-8.725-2.699-9.42-6.977-.112-.69.447-1.31 1.162-1.31.574 0 1.073.406 1.165.963.495 3.003 3.261 5.273 6.514 5.07 3.07-.191 5.572-2.624 5.776-5.623.24-3.487-2.57-6.404-6.08-6.458l-2.479-.014 2.71 2.007c.447.331.56.982.251 1.452a.946.946 0 01-1.369.253l-4.54-3.362a1.086 1.086 0 01-.133-1.6 1.049 1.049 0 01.338-1.253L7.847.818a.959.959 0 011.368.255 1.05 1.05 0 01-.244 1.425L6.459 4.32l2.093-.017c4.993.055 8.977 4.317 8.39 9.324z"/>'
  }
})
